import { useEffect } from 'react';
import { Modal, Button, Form, Input, message } from 'antd';
import { useTranslation } from 'react-i18next';
import useStore from '../../store/useStore';
import { Actions, IPermission } from '../../interfaces/global';
import { useMutationCreateEditPermission } from '../../hooks/useMutationData';
import './Modals.scss';
import { MESSAGE_DURATION } from '../../constants';

const ModalCreateEditPermission = () => {
  const { ui, setUi, data } = useStore();
  const { showModalPermission, action, permissionSelected } = ui;
  const { t } = useTranslation();
  const { Item } = Form;
  const [form] = Form.useForm();
  const { mutate, isSuccess, isError } = useMutationCreateEditPermission();

  const onFinish = (body: IPermission) => {
    if (body) {
      const duplicatePermissionName = data.some((permission: IPermission) => permission.name === body.name);
      if (duplicatePermissionName && action === Actions.Create) {
        message.error(`${t('modals.createEdit.duplicateName')}`, MESSAGE_DURATION);
      } else {
        mutate(body);
      }
    }
  };

  const onCloseModal = () => {
    setUi({ showModalPermission: false });
  };

  useEffect(() => {
    if (isError) {
      message.warning(
        action === Actions.Create
          ? `${t('modals.createEdit.messageErrorCreate')}`
          : `${t('modals.createEdit.messageErrorEdit')}`,
        MESSAGE_DURATION
      );
    }
  }, [isError]);

  useEffect(() => {
    if (isSuccess) {
      onCloseModal();
    }
  }, [isSuccess]);

  useEffect(() => {
    form.resetFields();
  }, [showModalPermission]);

  return (
    <Modal
      width={'50%'}
      onCancel={onCloseModal}
      visible={showModalPermission}
      centered
      title={
        action === Actions.Create ? `${t('modals.createEdit.titleCreate')}` : `${t('modals.createEdit.titleEdit')}`
      }
      forceRender
      footer={null}
    >
      <Form
        onFinish={onFinish}
        form={form}
        name="form"
        layout="vertical"
        className="search-po"
        initialValues={{
          name: action === Actions.Edit ? permissionSelected?.name : ''
        }}
        autoComplete="off"
      >
        <Item
          name="name"
          label={`${t('modals.createEdit.name')}`}
          rules={[
            {
              required: true,
              message: t('modals.createEdit.inputRequired'),
              whitespace: true
            }
          ]}
        >
          <Input placeholder={t('modals.createEdit.name')} id="name" disabled={action === Actions.Edit} />
        </Item>
        <Item
          name="description"
          label={`${t('table.permission.description')}`}
          rules={[{ required: true, message: t('modals.createEdit.inputRequired'), whitespace: true }]}
        >
          <Input placeholder={t('table.permission.description')} />
        </Item>
        <Item>
          <Button type="primary" htmlType="submit">
            <>{action === Actions.Create ? t('placeholders.createPermission') : t('placeholders.editPermission')}</>
          </Button>
        </Item>
      </Form>
    </Modal>
  );
};

export default ModalCreateEditPermission;
